(() => {
  const initialize = (section) => {
    if (
      !section ||
      section.dataset.croTestimonialsInitialized === "true"
    ) {
      return;
    }

    const track = section.querySelector(
      "[data-cro-testimonials-track]",
    );

    const slides = Array.from(
      section.querySelectorAll(
        "[data-cro-testimonial-slide]",
      ),
    );

    if (!track || slides.length === 0) {
      return;
    }

    section.dataset.croTestimonialsInitialized = "true";

    const previousButton = section.querySelector(
      "[data-cro-testimonials-prev]",
    );

    const nextButton = section.querySelector(
      "[data-cro-testimonials-next]",
    );

    const dotsContainer = section.querySelector(
      "[data-cro-testimonials-dots]",
    );

    const autoplay =
      section.dataset.autoplay === "true";

    const delay = Math.max(
      3000,
      Number(section.dataset.delay || 5000),
    );

    let index = 0;
    let timer = null;

    const getVisibleSlides = () => {
      if (window.innerWidth <= 749) {
        return 1;
      }

      const value = getComputedStyle(section)
        .getPropertyValue("--cro-columns")
        .trim();

      return Math.max(1, Number(value || 3));
    };

    const getMaximumIndex = () =>
      Math.max(
        0,
        slides.length - getVisibleSlides(),
      );

    const update = () => {
      index = Math.min(index, getMaximumIndex());

      const firstSlide = slides[0];
      const slideWidth =
        firstSlide.getBoundingClientRect().width;

      track.style.transform =
        `translateX(-${index * (slideWidth + 18)}px)`;

      if (dotsContainer) {
        Array.from(
          dotsContainer.children,
        ).forEach((dot, dotIndex) => {
          dot.classList.toggle(
            "is-active",
            dotIndex === index,
          );
        });
      }
    };

    const renderDots = () => {
      if (!dotsContainer) {
        return;
      }

      dotsContainer.innerHTML = "";

      for (
        let dotIndex = 0;
        dotIndex <= getMaximumIndex();
        dotIndex += 1
      ) {
        const dot = document.createElement("button");

        dot.type = "button";
        dot.className = "cro-testimonials__dot";
        dot.setAttribute(
          "aria-label",
          `Show testimonial group ${dotIndex + 1}`,
        );

        dot.addEventListener("click", () => {
          index = dotIndex;
          update();
          restartAutoplay();
        });

        dotsContainer.appendChild(dot);
      }
    };

    const next = () => {
      index =
        index >= getMaximumIndex()
          ? 0
          : index + 1;

      update();
    };

    const previous = () => {
      index =
        index <= 0
          ? getMaximumIndex()
          : index - 1;

      update();
    };

    const stopAutoplay = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      if (
        !autoplay ||
        slides.length <= getVisibleSlides()
      ) {
        return;
      }

      stopAutoplay();
      timer = window.setInterval(next, delay);
    };

    const restartAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    previousButton?.addEventListener(
      "click",
      () => {
        previous();
        restartAutoplay();
      },
    );

    nextButton?.addEventListener(
      "click",
      () => {
        next();
        restartAutoplay();
      },
    );

    section.addEventListener(
      "mouseenter",
      stopAutoplay,
    );

    section.addEventListener(
      "mouseleave",
      startAutoplay,
    );

    let touchStartX = 0;

    track.addEventListener(
      "touchstart",
      (event) => {
        touchStartX =
          event.touches[0]?.clientX || 0;
      },
      { passive: true },
    );

    track.addEventListener(
      "touchend",
      (event) => {
        const touchEndX =
          event.changedTouches[0]?.clientX || 0;

        const difference =
          touchStartX - touchEndX;

        if (Math.abs(difference) < 40) {
          return;
        }

        if (difference > 0) {
          next();
        } else {
          previous();
        }

        restartAutoplay();
      },
      { passive: true },
    );

    window.addEventListener("resize", () => {
      renderDots();
      update();
      restartAutoplay();
    });

    renderDots();
    update();
    startAutoplay();
  };

  const initializeAll = (root = document) => {
    root
      .querySelectorAll("[data-cro-testimonials]")
      .forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll(),
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => initializeAll(event.target),
  );
})();
